// extracted by mini-css-extract-plugin
export default {"container":"container_zCoZd","link":"link_LT8EF","linkIcon":"linkIcon_I2vf8"};